module.exports = __webpack_public_path__ + "img/selection-poster_jp.c375dfd.jpg";